// extracted by mini-css-extract-plugin
export default {"table":"dx5c6","head":"jA7YO","cell":"p9vte","row":"PuCax","actions-column":"A_D0f"};